import React, { useState } from 'react';

const ClientBillingInsurance: React.FC = () => {
  const [activeSubSection, setActiveSubSection] = useState<'insurance' | 'billing' | 'claims'>('insurance');

  return (
    <div style={{ padding: '32px' }}>
      {/* Page Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#FFFFFF', margin: '0 0 8px 0' }}>
          Client billing and insurance
        </h1>
        <p style={{ fontSize: '14px', color: '#87CEEB', margin: 0 }}>
          Manage insurance information, billing settings, and claims processing
        </p>
      </div>

      {/* Sub-navigation Tabs */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '32px',
        borderBottom: '1px solid #6CA6C1'
      }}>
        {[
          { id: 'insurance', label: 'Insurance Information' },
          { id: 'billing', label: 'Client Billing Settings' },
          { id: 'claims', label: 'Claims and Invoicing' }
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveSubSection(tab.id as any)}
            style={{
              padding: '12px 24px',
              border: 'none',
              borderBottom: activeSubSection === tab.id ? '3px solid #6CA6C1' : '3px solid transparent',
              backgroundColor: 'transparent',
              color: activeSubSection === tab.id ? '#6CA6C1' : '#FFFFFF',
              fontSize: '14px',
              fontWeight: activeSubSection === tab.id ? 600 : 400,
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Sections */}
      {activeSubSection === 'insurance' && (
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#FFFFFF', marginBottom: '16px' }}>
            Insurance Information Management
          </h2>
          <p style={{ fontSize: '14px', color: '#87CEEB', marginBottom: '24px' }}>
            Configure insurance providers, verification settings, and coverage rules
          </p>

          {/* Placeholder Content */}
          <div style={{
            backgroundColor: '#113F67',
            border: '1px solid #6CA6C1',
            borderRadius: '8px',
            padding: '32px',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '16px', color: '#FFFFFF', margin: '0 0 16px 0' }}>
              Insurance Information Settings
            </p>
            <p style={{ fontSize: '14px', color: '#87CEEB' }}>
              This section will include insurance provider management, verification settings, and eligibility checking.
            </p>
          </div>
        </div>
      )}

      {activeSubSection === 'billing' && (
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#FFFFFF', marginBottom: '16px' }}>
            Client Billing Settings
          </h2>
          <p style={{ fontSize: '14px', color: '#87CEEB', marginBottom: '24px' }}>
            Configure billing rates, payment terms, and invoicing preferences
          </p>

          {/* Placeholder Content */}
          <div style={{
            backgroundColor: '#113F67',
            border: '1px solid #6CA6C1',
            borderRadius: '8px',
            padding: '32px',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '16px', color: '#FFFFFF', margin: '0 0 16px 0' }}>
              Billing Configuration
            </p>
            <p style={{ fontSize: '14px', color: '#87CEEB' }}>
              This section will include rate schedules, payment terms, late fees, and billing cycle settings.
            </p>
          </div>
        </div>
      )}

      {activeSubSection === 'claims' && (
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#FFFFFF', marginBottom: '16px' }}>
            Claims and Invoicing
          </h2>
          <p style={{ fontSize: '14px', color: '#87CEEB', marginBottom: '24px' }}>
            Manage claims submission, tracking, and invoice generation
          </p>

          {/* Placeholder Content */}
          <div style={{
            backgroundColor: '#113F67',
            border: '1px solid #6CA6C1',
            borderRadius: '8px',
            padding: '32px',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '16px', color: '#FFFFFF', margin: '0 0 16px 0' }}>
              Claims Management
            </p>
            <p style={{ fontSize: '14px', color: '#87CEEB' }}>
              This section will include claims submission, status tracking, rejection handling, and invoice templates.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientBillingInsurance;
